module.exports = __webpack_public_path__ + "static/media/safetyplan-grey.50a69f16.svg";